// extracted by mini-css-extract-plugin
export var modal = "_eb-0";